module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-hr-2-a9aefde55cf0243f8f7766a72ab8fded.png";